module.exports = __webpack_public_path__ + "static/media/cellulite-stop.b36586de.jpeg";